import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy } from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SettingsState } from '../../store/settings/settings.state';
import { SamwinVersion } from '../../store/utility/samwin-version/samwin-version';

@Component({
   selector: 'samweb-authentication-process',
   templateUrl: './authentication-process.component.html',
   styleUrls: ['./authentication-process.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AuthenticationProcessComponent implements OnDestroy {
   @HostBinding('class') themeClass;

   private destroy$ = new Subject();

   public clientVersion = SamwinVersion.VERSION;

   constructor(private store: Store) {
      this.store
         .select(SettingsState.appliedTheme)
         .pipe(takeUntil(this.destroy$))
         .subscribe((theme) => {
            this.themeClass = theme.alternativeTheme;
         });
   }

   ngOnDestroy(): void {
      this.destroy$.next();
      this.destroy$.complete();
   }
}
